export const hotDeals = [
  {
    id: 'deal-1',
    name: '義式羊毛修身大衣',
    brand: 'MAX MARA',
    originalPrice: 28000,
    salePrice: 12800,
    discount: 46,
    tag: '本週最搶手',
    image: 'https://readdy.ai/api/search-image?query=elegant%20women%20oversized%20wool%20coat%20in%20warm%20camel%20beige%20color%2C%20high%20fashion%20product%20photography%2C%20minimalist%20clean%20white%20background%2C%20luxurious%20fabric%20texture%20visible%2C%20sophisticated%20tailoring%2C%20premium%20outerwear%2C%20soft%20warm%20lighting%2C%20fashion%20editorial%20style&width=480&height=600&seq=deal-coat-001&orientation=portrait',
  },
  {
    id: 'deal-2',
    name: '絲質花卉印花洋裝',
    brand: 'EQUIPMENT',
    originalPrice: 15000,
    salePrice: 6200,
    discount: 59,
    tag: '限量 5 件',
    image: 'https://readdy.ai/api/search-image?query=beautiful%20silk%20floral%20slip%20dress%20in%20cream%20and%20blush%20pink%20tones%2C%20luxury%20fashion%20product%20shot%2C%20clean%20minimal%20white%20background%2C%20flowing%20delicate%20fabric%2C%20feminine%20and%20elegant%2C%20premium%20quality%20silk%20garment%2C%20soft%20natural%20lighting%2C%20high-end%20brand%20photography&width=480&height=600&seq=deal-dress-001&orientation=portrait',
  },
  {
    id: 'deal-3',
    name: '寬版亞麻闊腳褲',
    brand: 'TOTEME',
    originalPrice: 9800,
    salePrice: 3800,
    discount: 61,
    tag: '新品到貨',
    image: 'https://readdy.ai/api/search-image?query=wide%20leg%20linen%20trousers%20in%20warm%20oatmeal%20beige%20cream%20color%2C%20minimalist%20fashion%20product%20photography%2C%20clean%20white%20studio%20background%2C%20relaxed%20yet%20elegant%20silhouette%2C%20premium%20linen%20fabric%20texture%2C%20Scandinavian%20style%20clothing%2C%20soft%20diffused%20lighting%2C%20high-end%20fashion%20brand%20product%20shot&width=480&height=600&seq=deal-pants-001&orientation=portrait',
  },
  {
    id: 'deal-4',
    name: '珍珠釦針織上衣',
    brand: 'COS',
    originalPrice: 6500,
    salePrice: 2400,
    discount: 63,
    tag: '多色可選',
    image: 'https://readdy.ai/api/search-image?query=elegant%20knit%20cardigan%20with%20pearl%20button%20detail%20in%20cream%20ivory%20white%2C%20luxury%20fashion%20product%20photography%2C%20minimal%20clean%20white%20background%2C%20premium%20knitwear%20texture%20visible%2C%20feminine%20and%20chic%20style%2C%20soft%20warm%20lighting%2C%20high-end%20fashion%20editorial%20product%20shot&width=480&height=600&seq=deal-knit-001&orientation=portrait',
  },
];
